import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { PostingCard } from "./postingCard";
import { Post } from "./PostModel";
import Pagination from "./pagination";
import defaultAxios from 'axios';
import { backendUrl } from "../../../common/constantVarialble";
import { useNavigate } from "react-router-dom";

function CreateServicePostHome() {

    const [totalItems, setTotalItems] = useState(0);
    const [posts, setPosts] = useState<Post[] | null>(null);
    const [searchParams] = useSearchParams();
    const page = searchParams.get("page");
    const pageIndex = page ? parseInt(page) : 1; // 현재 페이지에서 페이지 인덱스 계산
    const itemPerPage = 7; // 하나의 페이지에서 보여줄 포스팅 개수
    const pageCount = 5; // 페이지 앱바에서 보여줄 인덱스 개수
    const navigate = useNavigate();

    const getTotalItemCount = async () => {
        //PERCENT-POST-POSTING-S-LSTSERVICEPOSTINGTOTALCOUNT
        try {
            const { data } = await defaultAxios({
                method: "post",
                url: backendUrl,
                data: {
                    program_id: "PERCENT-POST-POSTING-S-LSTSERVICEPOSTINGTOTALCOUNT",
                    params: {},
                    initial_start_index: 0,
                    page_index: -1,
                    item_count: 0,
                },
            });

            return parseInt(data.data[0].count);


        } catch (error) {
            console.error(error);
            return null;
        }
    }

    const fetchPosts = async (pageIndex: number) => { // pageIndex 매개변수 추가
        try {
            const { data } = await defaultAxios({
                method: "post",
                url: backendUrl,
                data: {
                    program_id: "PERCENT-ENG-POSTING-S-LSTSERVICEPOSTING-PAGE",
                    params: {},
                    page_index: pageIndex, // 페이지 인덱스 동적 설정
                    initial_start_index: 0,
                    item_count: itemPerPage
                },
            });
            let postingList = data.data;
            return postingList;

        } catch (error) {
            console.error(error);
            return null;
        }
    }

    useEffect(() => {
        const loadPosts = async () => {
            window.scrollTo(0, 0); // 페이지 이동 시 스크롤 위치 맨 위로 초기화
            let totalItems = await getTotalItemCount();
            let postingList = await fetchPosts(pageIndex); // 페이지 인덱스로 패치
            if (postingList) {
                setPosts(postingList); // Assuming postingList contains a property posts                
            }
            if (totalItems) {
                setTotalItems(totalItems);
            }
        }

        loadPosts();
    }, [pageIndex]); // 페이지가 변경될 때마다 호출

    const onAddNewPostClick = () => {
        navigate("/admin/create-service-post");
    }

    const onPostingCardClick = (permlink: string) => {
        //navigate(`/sql/program?program_id=${searchTerm}`);
        navigate(`/admin/posting?permlink=${permlink}`)
    }

    return <div className="flex flex-1  min-h-screen bg-gray-800 px-72 py-12 flex-col">
        <button className="flex p-4 group relative overflow-hidden rounded-lg justify-center bg-indigo-400 text-lg font-bold text-white" onClick={onAddNewPostClick} >
            Add new post
        </button>
        <div className="absolute inset-0 h-full w-full scale-0 rounded-2xl transition-all duration-300 group-hover:scale-100 group-hover:bg-white/30"></div>
        <div className="list">
            {posts && (
                <>
                    {posts.map((post, i) => (
                        <div className="hover:cursor-pointer" onClick={() => onPostingCardClick(post.permlink)}>
                            <PostingCard post={post} key={i} />
                        </div>
                    ))}
                </>
            )}
        </div>
        <Pagination
            totalItems={totalItems} // 총 포스팅수
            currentPage={pageIndex} // currentPage를 pageIndex로 설정
            pageCount={pageCount} // 페이지네이셔 바에서 보여줄 페이지 개수
            itemCountPerPage={itemPerPage} // 페이지당 보여줄 포스팅 개수
        />
    </div>;
}

export { CreateServicePostHome };
